import { useFileInput } from "./Root";
// import { useAutoAnimate } from '@formkit/auto-animate/react'
import { FileItem } from "./FileItem";

export function FileList() {
  const { files, fileStatus } = useFileInput();
  // const [parent] = useAutoAnimate(/* optional config */)

  return (
    <div className="tw-mt-4 tw-space-y-3">
      {files.map((file, index) => {
        return (
          <FileItem
            key={file.name}
            name={file.name}
            size={file.size}
            status={fileStatus ? fileStatus[index] : undefined}
            index={index}
          />
        );
      })}
    </div>
  );
}
